msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/EditEditor.tsx
msgid " · Saving…"
msgstr " · 保存中…"

#: src/components/ToolCardMessage.tsx
msgid " (new)"
msgstr "（新建）"

#: src/components/ToolCardMessage.tsx
msgid "… (truncated)"
msgstr "…（已截断）"

#: src/components/MessageItem.tsx
msgid "(edited)"
msgstr "（已编辑）"

#. placeholder {0}: history.length
#: src/components/EditHistoryModal.tsx
msgid "{0, plural, one {# edit} other {# edits}}"
msgstr "{0, plural, one {共 # 次编辑} other {共 # 次编辑}}"

#. placeholder {0}: lines.length
#: src/components/ToolCardMessage.tsx
msgid "{0, plural, one {# line} other {# lines}}"
msgstr "{0, plural, one {# 行} other {# 行}}"

#. placeholder {0}: thread.message_count
#: src/components/MessageItem.tsx
msgid "{0, plural, one {# reply} other {# replies}}"
msgstr "{0, plural, one {# 条回复} other {# 条回复}}"

#. placeholder {0}: result.total
#: src/components/ToolCardMessage.tsx
msgid "{0, plural, one {# result} other {# results}}"
msgstr "{0, plural, one {# 条结果} other {# 条结果}}"

#. placeholder {0}: replies.length
#: src/components/DMThread.tsx
msgid "{0, plural, one {Hide # reply} other {Hide # replies}}"
msgstr "{0, plural, one {隐藏 # 条回复} other {隐藏 # 条回复}}"

#. placeholder {0}: replies.length
#: src/components/DMThread.tsx
msgid "{0, plural, one {Show # reply} other {Show # replies}}"
msgstr "{0, plural, one {显示 # 条回复} other {显示 # 条回复}}"

#. placeholder {0}: lines.length
#. placeholder {1}: result.totalLines
#: src/components/ToolCardMessage.tsx
msgid "{0}/{1} lines"
msgstr "{0}/{1} 行"

#: src/components/DshSessionChatView.tsx
msgid "{agentName} session"
msgstr "{agentName} 会话"

#: src/components/DirectMessageEmptyState.tsx
msgid "{displayName} is ready for context, questions, and task collaboration."
msgstr "可以向 {displayName} 提供上下文、提问或协作完成任务。"

#: src/components/FilesPanel.tsx
msgid "A file with that name already exists"
msgstr "已存在同名文件"

#: src/components/MessageInput.tsx
msgid "A message can contain at most 10 attachments"
msgstr "一条消息最多可包含 10 个附件"

#: src/components/SystemMessageBubble.tsx
msgid "Add agent"
msgstr "添加 Agent"

#: src/components/EmojiPickerPopover.tsx
#: src/components/ReactionAddButton.tsx
msgid "Add reaction"
msgstr "添加表情"

#: src/components/DirectMessagePanel.tsx
msgid "Agent"
msgstr "Agent"

#. placeholder {0}: i18n._(agentStates[state ?? 'ready'] ?? msg`Unknown`)
#: src/components/DirectMessageEmptyState.tsx
msgid "Agent · {0}"
msgstr "Agent · {0}"

#: src/components/AttachmentGrid.tsx
msgid "Attachment"
msgstr "附件"

#: src/components/MessageInput.tsx
msgid "Attachments can total at most 50 MB"
msgstr "附件总大小不能超过 50 MB"

#: src/components/MessageInput.tsx
msgid "Attachments cannot be sent to this native session. Send them from Messages or remove them first."
msgstr "无法向此原生会话发送附件。请在消息视图中发送，或先移除附件。"

#: src/components/SystemMessageBubble.tsx
msgid "Authorize"
msgstr "授权"

#: src/components/DshSessionChatView.tsx
msgid "Awaiting session"
msgstr "等待会话"

#: src/components/SlashCommandPicker.tsx
msgid "Back"
msgstr "返回"

#: src/components/Toolbar.tsx
msgid "Blockquote"
msgstr "引用"

#: src/components/Toolbar.tsx
msgid "Bold (Ctrl+B)"
msgstr "粗体（Ctrl+B）"

#: src/components/Toolbar.tsx
msgid "Bullet list (Ctrl+Shift+8)"
msgstr "无序列表（Ctrl+Shift+8）"

#: src/components/DirectMessageEmptyState.tsx
msgid "Busy"
msgstr "忙碌"

#: src/components/CommandParamForm.tsx
#: src/components/MarkdownEditor.tsx
#: src/components/MessageItem.tsx
msgid "Cancel"
msgstr "取消"

#: src/commands/builtins.ts
msgid "Change your display name"
msgstr "修改显示名"

#: src/components/MessageList.tsx
msgid "channel"
msgstr "频道"

#: src/commands/builtins.ts
msgid "Channel member roster is unavailable. Join the channel to use /status."
msgstr "无法查看频道成员。请加入频道后使用 /status。"

#: src/components/SlashCommandPicker.tsx
msgid "Choose agent"
msgstr "选择 Agent"

#: src/components/FilesPanel.tsx
msgid "Clear"
msgstr "清除"

#: src/commands/builtins.ts
msgid "Clear local chat history"
msgstr "清除本地聊天记录"

#: src/commands/builtins.ts
msgid "Clear local chat history? This only clears the local display and does not affect server data."
msgstr "确定清除本地聊天记录？此操作仅清除本地显示，不影响服务端数据。"

#: src/components/EditHistoryModal.tsx
#: src/components/MarkdownEditor.tsx
#: src/components/SlashCommandPicker.tsx
msgid "Close"
msgstr "关闭"

#: src/components/DirectMessagePanel.tsx
msgid "Close direct message"
msgstr "关闭私信"

#: src/components/FileViewer.tsx
#: src/components/RemoteFileViewer.tsx
msgid "Close file preview"
msgstr "关闭文件预览"

#: src/components/ThreadPanelHeader.tsx
msgid "Close thread"
msgstr "关闭讨论串"

#: src/components/DshSessionChatView.tsx
msgid "Closed"
msgstr "已关闭"

#: src/components/Toolbar.tsx
msgid "Code block"
msgstr "代码块"

#: src/components/MessageInput.tsx
msgid "Command failed"
msgstr "命令执行失败"

#: src/components/CommandResultCard.tsx
msgid "Completed"
msgstr "已完成"

#: src/components/DshSessionChatView.tsx
msgid "Connecting"
msgstr "连接中"

#: src/components/DshSessionChatView.tsx
msgid "Connection interrupted. Check each message’s send status before retrying."
msgstr "连接已中断。重试前请检查每条消息的发送状态。"

#: src/lib/interaction-responses.ts
msgid "Connection is disconnected."
msgstr "连接已断开。"

#: src/lib/interaction-responses.ts
msgid "Connection is disconnected. The answer may have been accepted."
msgstr "连接已断开，回答可能已被接受。"

#: src/hooks/useDMEdit.ts
msgid "Could not edit message: the conversation or message is missing."
msgstr "无法编辑消息：缺少会话或消息。"

#: src/components/EditEditor.tsx
msgid "Ctrl+Enter to save · Esc to cancel"
msgstr "Ctrl+Enter 保存 · Esc 取消"

#: src/components/MarkdownEditor.tsx
msgid "Ctrl+S to save · Esc to cancel"
msgstr "Ctrl+S 保存 · Esc 取消"

#: src/components/FilesPanel.tsx
#: src/components/MessageItem.tsx
msgid "Delete"
msgstr "删除"

#. placeholder {0}: file.name
#: src/components/FilesPanel.tsx
msgid "Delete {0}?"
msgstr "确定删除 {0}？"

#: src/components/MessageItem.tsx
msgid "Delete this message?"
msgstr "确定删除这条消息？"

#: src/components/DirectMessageEmptyState.tsx
#: src/components/DirectMessagePanel.tsx
msgid "Direct message"
msgstr "私信"

#: src/components/MentionList.tsx
msgid "Direct messages are for two people. Create a channel to include others."
msgstr "私信仅限两人，想加人请新建频道。"

#: src/components/DshSessionChatView.tsx
msgid "Disconnected"
msgstr "连接已断开"

#: src/commands/builtins.ts
msgid "Display name changed:"
msgstr "显示名已修改："

#: src/components/ThreadPanelHeader.tsx
msgid "Dock the thread beside the channel"
msgstr "将讨论串固定在频道旁"

#: src/components/AttachmentGrid.tsx
#: src/components/FileViewer.tsx
msgid "Download"
msgstr "下载"

#. placeholder {0}: file.filename
#: src/components/AttachmentGrid.tsx
msgid "Download {0}"
msgstr "下载 {0}"

#: src/components/FileViewer.tsx
msgid "Download file"
msgstr "下载文件"

#: src/components/FileViewer.tsx
msgid "Downloading…"
msgstr "正在下载…"

#: src/components/FilesPanel.tsx
msgid "Drop files here to upload"
msgstr "拖放文件到此处上传"

#: src/components/MessageInput.tsx
msgid "Each attachment must be 10 MB or smaller"
msgstr "每个附件不能超过 10 MB"

#: src/components/MessageItem.tsx
#: src/components/viewers/MarkdownViewer.tsx
msgid "Edit"
msgstr "编辑"

#: src/components/MarkdownEditor.tsx
msgid "Edit {fileName}"
msgstr "编辑 {fileName}"

#: src/components/EditHistoryModal.tsx
msgid "Edit history"
msgstr "编辑历史"

#. placeholder {0}: formatTime(message.edited_at, i18n)
#: src/components/MessageItem.tsx
msgid "Edited at {0}"
msgstr "编辑于 {0}"

#: src/components/RemoteTree.tsx
msgid "Empty directory"
msgstr "空目录"

#: src/commands/builtins.ts
msgid "Enter the channel topic…"
msgstr "输入频道主题…"

#: src/components/DirectMessageEmptyState.tsx
msgid "Error"
msgstr "错误"

#: src/components/CommandParamForm.tsx
msgid "Execute"
msgstr "执行"

#: src/components/CommandResultCard.tsx
msgid "Executing…"
msgstr "执行中…"

#. placeholder {0}: typeof result.exitCode === 'number' ? result.exitCode : '?'
#: src/components/ToolCardMessage.tsx
msgid "Exit code: {0}"
msgstr "退出码：{0}"

#: src/components/ThreadPanelHeader.tsx
msgid "Expand session to workspace"
msgstr "将会话铺满工作区"

#: src/components/CommandResultCard.tsx
#: src/components/DshSessionChatView.tsx
msgid "Failed"
msgstr "失败"

#: src/components/ReactionAddButton.tsx
msgid "Failed to add reaction. Please try again."
msgstr "添加表情失败，请重试。"

#: src/components/FileViewer.tsx
msgid "Failed to download file"
msgstr "下载文件失败"

#: src/hooks/useDMEdit.ts
msgid "Failed to edit message"
msgstr "编辑消息失败"

#: src/components/RemoteTree.tsx
msgid "Failed to load directory"
msgstr "加载目录失败"

#: src/components/EditHistoryModal.tsx
msgid "Failed to load edit history"
msgstr "加载编辑历史失败"

#: src/components/FileViewer.tsx
msgid "Failed to load file"
msgstr "加载文件失败"

#: src/components/viewers/PdfViewer.tsx
msgid "Failed to load PDF preview"
msgstr "加载 PDF 预览失败"

#: src/components/FileLink.tsx
#: src/components/RemoteTree.tsx
msgid "Failed to read file"
msgstr "读取文件失败"

#: src/components/viewers/PdfViewer.tsx
msgid "Failed to render this PDF page"
msgstr "渲染此 PDF 页面失败"

#: src/components/FilesPanel.tsx
msgid "File"
msgstr "文件"

#: src/components/FileLink.tsx
#: src/components/RemoteTree.tsx
msgid "File is too large to preview"
msgstr "文件过大，无法预览"

#: src/components/FileLink.tsx
msgid "File not found"
msgstr "文件不存在"

#: src/components/FileLink.tsx
msgid "File read timed out"
msgstr "文件读取超时"

#: src/components/FilesPanel.tsx
msgid "File search failed"
msgstr "文件搜索失败"

#: src/components/FilesPanel.tsx
msgid "Files"
msgstr "文件"

#: src/components/FilesPanel.tsx
msgid "Folder"
msgstr "文件夹"

#: src/components/FilesPanel.tsx
msgid "Folder name:"
msgstr "文件夹名称："

#: src/components/AttachmentGrid.tsx
msgid "Full size image"
msgstr "完整尺寸图片"

#: src/components/ThreadPanelHeader.tsx
msgid "Go to channel"
msgstr "前往频道"

#: src/components/HeartbeatCollapsed.tsx
msgid "Heartbeat × {count}"
msgstr "心跳 × {count}"

#: src/components/HeartbeatCollapsed.tsx
#: src/components/MessageItem.tsx
msgid "Heartbeat: status update requested"
msgstr "心跳：已请求状态更新"

#: src/components/DirectMessageEmptyState.tsx
msgid "Help me with a task"
msgstr "帮我处理一项任务"

#: src/components/DshSessionChatView.tsx
msgid "Hide receipt"
msgstr "隐藏回执"

#: src/components/DshSessionChatView.tsx
msgid "Hide this receipt in this browser. The message stays in Messages."
msgstr "在此浏览器中隐藏回执。消息仍保留在消息视图中。"

#: src/components/DirectMessageEmptyState.tsx
#: src/components/DshSessionChatView.tsx
msgid "Idle"
msgstr "空闲"

#: src/components/MessageItem.tsx
msgid "Image failed to load"
msgstr "图片加载失败"

#: src/components/FilesPanel.tsx
msgid "Image file"
msgstr "图片文件"

#: src/components/MessageItem.tsx
msgid "Image links must use http(s):// or a same-origin path"
msgstr "图片链接必须是 http(s):// 网址或同源路径"

#: src/components/Toolbar.tsx
msgid "Inline code (Ctrl+E)"
msgstr "行内代码（Ctrl+E）"

#: src/commands/builtins.ts
msgid "Invite a user to the channel"
msgstr "邀请用户加入频道"

#: src/components/Toolbar.tsx
msgid "Italic (Ctrl+I)"
msgstr "斜体（Ctrl+I）"

#. placeholder {0}: parentChannel.name
#: src/components/ThreadPanel.tsx
msgid "Join #{0} to reply"
msgstr "加入 #{0} 后回复"

#: src/components/ThreadPanel.tsx
msgid "Join the channel to reply"
msgstr "加入频道后回复"

#: src/components/ThreadPanel.tsx
msgid "Joining…"
msgstr "加入中…"

#: src/components/DshSessionChatView.tsx
msgid "Jump to latest ↓"
msgstr "跳至最新 ↓"

#: src/components/SystemMessageBubble.tsx
msgid "Later"
msgstr "稍后"

#: src/commands/builtins.ts
msgid "Leave the current channel"
msgstr "离开当前频道"

#: src/commands/builtins.ts
msgid "Leave the current channel?"
msgstr "确定离开当前频道？"

#: src/components/MessageList.tsx
msgid "Load earlier messages"
msgstr "加载更早消息"

#: src/components/DirectMessagePanel.tsx
msgid "Loading conversation…"
msgstr "加载会话中…"

#: src/components/viewers/PdfViewer.tsx
msgid "Loading PDF…"
msgstr "正在加载 PDF…"

#: src/components/DshSessionChatView.tsx
msgid "Loading saved activity…"
msgstr "加载已保存的动态…"

#: src/components/DshSessionChatView.tsx
#: src/components/FilesPanel.tsx
#: src/components/FileViewer.tsx
#: src/components/MessageList.tsx
#: src/components/RemoteTree.tsx
msgid "Loading…"
msgstr "正在加载…"

#: src/commands/builtins.ts
msgid "Local chat history cleared"
msgstr "本地聊天记录已清除"

#: src/components/DshSessionChatView.tsx
msgid "Local history"
msgstr "本地历史"

#: src/commands/builtins.ts
msgid "Members: {memberCount} ({onlineCount} online)"
msgstr "成员：{memberCount}（在线 {onlineCount}）"

#: src/components/DirectMessageEmptyState.tsx
msgid "Message {displayName}"
msgstr "向 {displayName} 发消息"

#: src/components/MessageItem.tsx
msgid "Message actions"
msgstr "消息操作"

#: src/hooks/useDMEdit.ts
msgid "Message content cannot be empty."
msgstr "消息内容不能为空。"

#: src/components/SlashCommandPicker.tsx
msgid "Multiple agents provide this command:"
msgstr "多个 Agent 提供此命令："

#: src/commands/builtins.ts
msgid "New display name…"
msgstr "新显示名…"

#: src/components/FilesPanel.tsx
msgid "New folder"
msgstr "新建文件夹"

#: src/components/MessageList.tsx
msgid "New messages"
msgstr "新消息"

#: src/components/DshSessionChatView.tsx
msgid "New task activity is unavailable because earlier requests occupy the local display capacity."
msgstr "较早的请求已占满本地显示容量，无法显示新的任务活动。"

#: src/components/ThreadPanel.tsx
msgid "New thread"
msgstr "新建讨论串"

#: src/components/FilesPanel.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "Next page"
msgstr "下一页"

#: src/components/SlashCommandPicker.tsx
msgid "No commands found"
msgstr "没有找到命令"

#: src/components/FilesPanel.tsx
msgid "No files yet"
msgstr "暂无文件"

#: src/components/FilesPanel.tsx
msgid "No matching files"
msgstr "没有匹配的文件"

#: src/components/DshSessionChatView.tsx
msgid "No session activity yet"
msgstr "暂无会话动态"

#: src/commands/builtins.ts
msgid "None"
msgstr "无"

#: src/components/Toolbar.tsx
msgid "Numbered list (Ctrl+Shift+9)"
msgstr "有序列表（Ctrl+Shift+9）"

#: src/components/DirectMessageEmptyState.tsx
msgid "Offline"
msgstr "离线"

#: src/commands/builtins.ts
msgid "Offline:"
msgstr "离线："

#: src/components/DshSessionChatView.tsx
msgid "Older activity was removed to make room in this browser."
msgstr "为释放浏览器空间，较早的动态已被移除。"

#: src/components/DirectMessageEmptyState.tsx
msgid "Online"
msgstr "在线"

#: src/commands/builtins.ts
msgid "Online:"
msgstr "在线："

#: src/components/DshSessionChatView.tsx
#: src/lib/interaction-responses.ts
msgid "Only the agent owner can respond."
msgstr "仅 Agent 所有者可以回复。"

#: src/components/FileViewer.tsx
msgid "Only the first 1 MB is shown. Download the file to view all content."
msgstr "仅显示前 1 MB。请下载文件以查看全部内容。"

#: src/components/FilesPanel.tsx
msgid "Open"
msgstr "打开"

#: src/commands/builtins.ts
msgid "Open a direct message with a user"
msgstr "打开与用户的私信"

#. placeholder {0}: img.filename
#: src/components/AttachmentGrid.tsx
msgid "Open image {0}"
msgstr "打开图片 {0}"

#: src/components/AttachmentGrid.tsx
msgid "Open image attachment"
msgstr "打开图片附件"

#: src/components/DshSessionChatView.tsx
msgid "Open in Messages"
msgstr "在消息视图中打开"

#: src/components/DshSessionChatView.tsx
msgid "Open Messages to retry"
msgstr "打开消息视图重试"

#: src/components/DirectMessageEmptyState.tsx
msgid "Or write a message below."
msgstr "也可以在下方输入消息。"

#. placeholder {0}: document.numPages
#: src/components/viewers/PdfViewer.tsx
msgid "Page {pageNumber} of {0}"
msgstr "第 {pageNumber} 页，共 {0} 页"

#: src/components/RemoteTree.tsx
msgid "Parent folder"
msgstr "上级目录"

#: src/components/viewers/PdfViewer.tsx
msgid "PDF page {pageNumber}"
msgstr "PDF 第 {pageNumber} 页"

#: src/components/viewers/PdfViewer.tsx
msgid "PDF preview controls"
msgstr "PDF 预览控件"

#: src/components/viewers/DocxViewer.tsx
msgid "Preparing document preview…"
msgstr "正在准备文档预览…"

#: src/components/FileViewer.tsx
#: src/components/RemoteFileViewer.tsx
msgid "Preview is not supported for this file type"
msgstr "不支持预览此文件类型"

#: src/components/FilesPanel.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "Previous page"
msgstr "上一页"

#: src/components/ReactionAddButton.tsx
msgid "React"
msgstr "添加表情"

#: src/components/ThreadPanel.tsx
msgid "Read-only"
msgstr "只读"

#: src/components/DshSessionChatView.tsx
msgid "Read-only · This saved request is not currently confirmed as active."
msgstr "只读 · 尚未确认此已保存请求仍然有效。"

#: src/components/DirectMessageEmptyState.tsx
msgid "Ready"
msgstr "就绪"

#: src/components/SystemMessageBubble.tsx
msgid "Reconnect"
msgstr "重连"

#: src/components/DshSessionChatView.tsx
msgid "Reconnecting"
msgstr "重连中"

#: src/components/DshSessionChatView.tsx
msgid "Recovery failed"
msgstr "恢复失败"

#: src/components/SystemMessageBubble.tsx
msgid "Reject"
msgstr "拒绝"

#: src/components/DshSessionChatView.tsx
msgid "Remote Control is paused in this browser because complete session state could not be saved. The view is stale. The agent may still be running."
msgstr "无法保存完整会话状态，远程控制已在此浏览器中暂停。当前视图已过时，Agent 可能仍在运行。"

#: src/components/DshSessionChatView.tsx
msgid "Remote Control is waiting for a complete session synchronization. Saved history is stale and controls are unavailable."
msgstr "远程控制正在等待完整会话同步。已保存的历史记录已过时，控制暂不可用。"

#: src/components/RemoteTree.tsx
msgid "Remote node is offline"
msgstr "远程节点离线"

#. placeholder {0}: file.name
#: src/components/MessageInput.tsx
msgid "Remove {0}"
msgstr "移除{0}"

#: src/components/MessageInput.tsx
msgid "Remove attachment"
msgstr "移除附件"

#: src/components/MessageInput.tsx
msgid "Remove these attachments before sending, or send them from Messages."
msgstr "请先移除这些附件，或在消息视图中发送。"

#: src/components/FilesPanel.tsx
msgid "Rename"
msgstr "重命名"

#: src/components/FilesPanel.tsx
msgid "Rename failed"
msgstr "重命名失败"

#: src/components/FilesPanel.tsx
msgid "Rename to:"
msgstr "重命名为："

#: src/components/viewers/PdfViewer.tsx
msgid "Rendering page…"
msgstr "正在渲染页面…"

#: src/components/DMThread.tsx
msgid "Reply…"
msgstr "回复..."

#: src/components/viewers/ImageViewer.tsx
msgid "Reset zoom"
msgstr "重置缩放"

#: src/lib/interaction-responses.ts
msgid "Response confirmation timed out. The answer may have been accepted."
msgstr "回答确认超时，回答可能已被接受。"

#: src/lib/interaction-responses.ts
msgid "Response could not be sent. The answer may have been accepted."
msgstr "无法发送回答，回答可能已被接受。"

#: src/components/ThreadPanelHeader.tsx
msgid "Restore session width"
msgstr "恢复会话宽度"

#: src/components/DshSessionChatView.tsx
msgid "Resynchronize session"
msgstr "重新同步会话"

#: src/components/MessageItem.tsx
msgid "Retry"
msgstr "重试"

#: src/components/DshSessionChatView.tsx
msgid "Retry history"
msgstr "重试加载历史"

#: src/components/FilesPanel.tsx
msgid "Root"
msgstr "根目录"

#: src/components/MarkdownEditor.tsx
msgid "Save"
msgstr "保存"

#: src/components/FilesPanel.tsx
msgid "Search"
msgstr "搜索"

#: src/components/FilesPanel.tsx
msgid "Search files"
msgstr "搜索文件"

#: src/components/FilesPanel.tsx
msgid "Searching…"
msgstr "正在搜索…"

#: src/commands/builtins.ts
msgid "Select a user…"
msgstr "选择用户…"

#: src/components/DMThread.tsx
msgid "Send"
msgstr "发送"

#: src/components/DshSessionChatView.tsx
msgid "Send a message to {agentName}. Messages, reasoning, and tools will appear here as they arrive."
msgstr "向 {agentName} 发送消息。收到的消息、推理和工具活动将显示在这里。"

#: src/components/MessageInput.tsx
#: src/components/MessageItem.tsx
msgid "Send failed"
msgstr "发送失败"

#: src/components/MessageInput.tsx
msgid "Send message"
msgstr "发送消息"

#: src/components/DshSessionChatView.tsx
msgid "Send not confirmed"
msgstr "发送尚未确认"

#: src/components/DshSessionChatView.tsx
#: src/components/MessageInput.tsx
#: src/components/MessageItem.tsx
msgid "Sending…"
msgstr "发送中…"

#: src/components/MessageItem.tsx
msgid "Sent"
msgstr "已发送"

#: src/components/DshSessionChatView.tsx
msgid "Sent to conversation"
msgstr "已发送至对话"

#: src/components/DshSessionChatView.tsx
msgid "Session unavailable"
msgstr "会话不可用"

#: src/components/DshSessionChatView.tsx
msgid "Session updates stopped. Restore the agent connection to continue. Saved history may be stale."
msgstr "会话更新已停止。请恢复智能体连接后继续。已保存的历史记录可能不是最新状态。"

#: src/commands/builtins.ts
msgid "Set the channel topic"
msgstr "设置频道主题"

#: src/commands/builtins.ts
msgid "Show all available commands"
msgstr "显示所有可用命令"

#: src/commands/builtins.ts
msgid "Show channel status"
msgstr "显示频道状态"

#: src/components/DirectMessageEmptyState.tsx
msgid "Show your current context"
msgstr "展示当前上下文"

#: src/components/SlashCommandPicker.tsx
msgid "Slash commands"
msgstr "斜杠命令"

#: src/components/viewers/DocxViewer.tsx
msgid "Some document content could not be displayed."
msgstr "部分文档内容无法显示。"

#: src/components/DshSessionChatView.tsx
msgid "Stale"
msgstr "已过时"

#: src/components/DirectMessageEmptyState.tsx
msgid "Start a conversation with {displayName}"
msgstr "开始与 {displayName} 对话"

#: src/components/DshSessionChatView.tsx
msgid "Synchronization failed. Restore available storage or the session connection, then retry."
msgstr "同步失败。请释放存储空间或恢复会话连接，然后重试。"

#: src/components/DshSessionChatView.tsx
msgid "Synchronizing…"
msgstr "正在同步…"

#: src/commands/builtins.ts
#: src/components/MessageItem.tsx
#: src/components/SlashCommandPicker.tsx
msgid "System"
msgstr "系统"

#: src/components/FilesPanel.tsx
msgid "Text file"
msgstr "文本文件"

#: src/lib/interaction-responses.ts
msgid "The agent could not accept this response. The request may already be resolved."
msgstr "Agent 无法接受此回答，请求可能已处理完毕。"

#: src/lib/interaction-responses.ts
msgid "The agent is disconnected."
msgstr "Agent 已断开连接。"

#: src/components/FileLink.tsx
msgid "The agent is offline. Unable to read the file."
msgstr "Agent 离线，无法读取文件。"

#: src/components/CommandResultCard.tsx
msgid "The agent may be offline"
msgstr "Agent 可能不在线"

#: src/lib/interaction-responses.ts
msgid "The agent returned an invalid interaction result."
msgstr "Agent 返回了无效的交互结果。"

#: src/lib/interaction-responses.ts
msgid "The Agent returned an invalid interaction result."
msgstr "Agent 返回了无效的交互结果。"

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "The attachment filename is not allowed: {0}"
msgstr "不允许使用此附件文件名：{0}"

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "The attachment type does not match its extension: {0}"
msgstr "附件类型与扩展名不匹配：{0}"

#: src/components/DshSessionChatView.tsx
msgid "The connection is unavailable. This request is read-only."
msgstr "连接不可用，此请求为只读。"

#: src/lib/interaction-responses.ts
msgid "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."
msgstr "操作结果尚未确认，请检查会话状态后再重试。草稿已保留。"

#: src/lib/interaction-responses.ts
msgid "The interaction response is invalid or too large. Shorten the answer and try again."
msgstr "交互回答无效或过长。请缩短回答后重试。"

#: src/lib/interaction-responses.ts
msgid "The interaction response is invalid."
msgstr "交互回答无效。"

#: src/lib/interaction-responses.ts
msgid "The interaction response is too large for this connection. It was not sent; the original request is unchanged."
msgstr "交互响应超出当前连接的大小限制，尚未发送；原始请求保持不变。"

#: src/components/DshSessionChatView.tsx
msgid "The latest history could not be loaded. Live activity continues."
msgstr "无法加载最新历史，实时活动仍会继续。"

#. placeholder {0}: filename ?? ''
#: src/components/MessageInput.tsx
msgid "This attachment type is not supported: {0}"
msgstr "不支持此附件类型：{0}"

#: src/components/DshSessionChatView.tsx
msgid "This conversation is read-only."
msgstr "此会话为只读。"

#: src/components/FileViewer.tsx
#: src/components/viewers/DocxViewer.tsx
msgid "This DOCX file is damaged or cannot be previewed"
msgstr "此 DOCX 文件已损坏或无法预览"

#: src/components/FileViewer.tsx
msgid "This file is not valid UTF-8 text"
msgstr "此文件不是有效的 UTF-8 文本"

#: src/components/FileViewer.tsx
msgid "This file is too large to preview safely"
msgstr "此文件过大，无法安全预览"

#: src/lib/interaction-responses.ts
msgid "This interaction is no longer available."
msgstr "此交互已不可用。"

#: src/components/DshSessionChatView.tsx
msgid "This interaction is unavailable for the current session."
msgstr "当前会话无法使用此交互。"

#: src/components/viewers/DocxViewer.tsx
msgid "This is a simplified read-only preview. Layout may differ from Microsoft Word."
msgstr "这是简化的只读预览，版式可能与 Microsoft Word 不同。"

#: src/components/MessageList.tsx
msgid "This is the beginning of the #{channelName} channel."
msgstr "这是 #{channelName} 频道的起点。"

#: src/components/MessageList.tsx
msgid "This is the beginning of the conversation"
msgstr "这是会话的起点"

#: src/components/DirectMessageEmptyState.tsx
msgid "This is the beginning of your private conversation with {displayName}."
msgstr "这是你与 {displayName} 私密对话的起点。"

#: src/components/MessageItem.tsx
msgid "This message was deleted"
msgstr "此消息已删除"

#: src/components/DshSessionChatView.tsx
msgid "This native session cannot provide its complete pending requests. Resume it through Borgee before retrying Remote Control."
msgstr "此原生会话无法提供完整的待处理请求。请通过 Borgee 恢复会话，再重试远程控制。"

#: src/components/FileLink.tsx
msgid "This path is outside the allowed read scope"
msgstr "该路径不在允许读取范围内"

#: src/components/FileViewer.tsx
#: src/components/viewers/PdfViewer.tsx
msgid "This PDF is damaged or is not a valid PDF"
msgstr "此 PDF 已损坏或不是有效的 PDF 文件"

#: src/components/viewers/PdfViewer.tsx
msgid "This PDF is password protected and cannot be previewed"
msgstr "此 PDF 受密码保护，无法预览"

#: src/components/DshSessionChatView.tsx
msgid "This session is not available yet."
msgstr "该会话暂不可用。"

#: src/components/DshSessionChatView.tsx
msgid "This view keeps activity received in this browser. Earlier activity is not downloaded."
msgstr "此视图保留在当前浏览器中收到的动态，不会下载更早的动态。"

#: src/components/MessageItem.tsx
#: src/components/ThreadPanel.tsx
msgid "Thread"
msgstr "讨论串"

#: src/components/CommandResultCard.tsx
msgid "Timed out"
msgstr "已超时"

#. placeholder {0}: recipientAgent.name
#: src/components/MessageInput.tsx
msgid "To @{0}"
msgstr "发送给 @{0}"

#: src/lib/interaction-responses.ts
msgid "Too many interaction responses are pending."
msgstr "等待确认的交互回答过多。"

#: src/commands/builtins.ts
msgid "Topic:"
msgstr "主题："

#: src/components/MentionPicker.tsx
msgid "Type @ to mention channel members…"
msgstr "输入 @ 提到频道成员…"

#: src/components/DirectMessageEmptyState.tsx
#: src/components/MessageItem.tsx
#: src/components/ThreadPanel.tsx
msgid "Unknown"
msgstr "未知"

#: src/components/MessageInput.tsx
msgid "Unknown type"
msgstr "未知类型"

#: src/components/DshSessionChatView.tsx
msgid "Updates stopped"
msgstr "会话更新已停止"

#: src/components/FilesPanel.tsx
msgid "Upload"
msgstr "上传"

#: src/components/MessageInput.tsx
msgid "Upload files"
msgstr "上传文件"

#: src/components/FilesPanel.tsx
msgid "Upload or drag files here"
msgstr "上传或拖放文件到此处"

#: src/components/MessageItem.tsx
msgid "Uploaded image"
msgstr "已上传的图片"

#: src/commands/builtins.ts
msgid "Usage: {usage}"
msgstr "用法：{usage}"

#: src/components/DshSessionChatView.tsx
msgid "Waiting for you"
msgstr "等待你的回复"

#: src/components/DirectMessageEmptyState.tsx
msgid "What are you working on?"
msgstr "你正在做什么？"

#: src/components/DshSessionChatView.tsx
msgid "Working"
msgstr "工作中"

#: src/components/MessageInput.tsx
msgid "Write a message… (Enter to send, Ctrl+Enter for a new line)"
msgstr "输入消息…（Enter 发送，Ctrl+Enter 换行）"

#: src/components/MessageItem.tsx
msgid "Yesterday {timeStr}"
msgstr "昨天 {timeStr}"

#: src/components/DshSessionChatView.tsx
msgid "You"
msgstr "你"

#: src/components/viewers/PdfViewer.tsx
msgid "Zoom in"
msgstr "放大"

#: src/components/viewers/PdfViewer.tsx
msgid "Zoom out"
msgstr "缩小"
